import { useUnit } from "effector-react";
import { Navigate } from "react-router-dom";
import { UserStore } from "../../stores/UserStore/UserStore";
import { ROLES } from "../../types/user.types";
import { privateRoutes } from "../../components/NavWrapper/Menus.consts";

export default function Redirect() {
  const { role } = useUnit(UserStore);

  if (role === ROLES.OPERATOR) {
    return <Navigate to={privateRoutes.washingOperator.path} replace />;
  }

  if (role === ROLES.VIEWER) {
    return <Navigate to={privateRoutes.dashboard.path} replace />;
  }

  if (role === ROLES.USER) {
    return <Navigate to={privateRoutes.sales.path} replace />;
  }

  return <Navigate to={privateRoutes.sales.path} replace />;
}
